import React from "react";
import {
  Page,
  Document,
  Image,
  StyleSheet,
  Font,
  View,
  Text
} from "@react-pdf/renderer";
import watermark from "../../assets/images/logo.PNG";
import bahijR from "../../assets/fonts/Bahij-Nazanin-Regular.ttf";
import bahijB from "../../assets/fonts/Bahij-Nazanin-Bold.ttf";
import amiriR from "../../assets/fonts/Amiri-Regular.ttf";
import amiriB from "../../assets/fonts/Amiri-Bold.ttf";
import Table from "../invoices/Table";

export default function InvoicePdf({ v }) {
  Font.register({ family: "bahijR", src: bahijR });
  Font.register({ family: "bahijB", src: bahijB });
  Font.register({ family: "amiriR", src: amiriR });
  Font.register({ family: "amiriB", src: amiriB });

  const nf = n => v?.com?.NumberFormatter(n);

  const getSplitText = t => (t ? t.split(" ") : []);

  const cw = str => v?.com?.capitalizeWords(str);

  const getTopHeader = () => {
    return (
      <View style={styles.header}>
        <View
          style={{
            width: v.model?.mImag === undefined ? "100%" : "50%",
            color: "white",
            fontSize: 15,
            marginRight: 10,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <View style={[styles1.flexRowReverse]}>
            {getSplitText(v.model?.company?.name_af).map((word, idx) => {
              return (
                <Text
                  style={{ ...styles1.ml1, fontFamily: "bahijB", fontSize: 20 }}
                  key={idx}
                >
                  {word}
                </Text>
              );
            })}
          </View>
          <Text style={{ fontSize: 13 }}>{cw(v.model?.company?.name_en)}</Text>
        </View>
        {v.model?.mImage && (
          <View
            style={{
              width: "45%",
              backgroundColor: "white",
              marginTop: 5,
              marginRight: 20,
              marginBottom: 5
            }}
          >
            <Image style={styles.logo_h} src={v.model?.mImage} />
          </View>
        )}
      </View>
    );
  };

  const getRedHeader = () => {
    return (
      <View
        style={{
          width: "100%",
          height: 35,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <View
          style={{
            ...styles.redHeader
          }}
        >
          <Text style={{ fontWeight: "bold", fontSize: 14 }}>
            Invoice #: {v?.model?.company_inovice_number}
          </Text>
        </View>

        <Text
          style={{
            fontSize: "25px",
            fontWeight: "bold",
            height: 32,
            transform: "scale(1, 1.8)",
            color: "#8B0000"
          }}
        >
          INVOICE
        </Text>

        <View
          style={{
            ...styles.redHeader,
            justifyContent: "center",
            paddingRight: 10
          }}
        >
          {/*
          <Text style={{ fontWeight: "bold", fontSize: 14 }}>
            Date: {v.com.getDate(v.model?.shipping_date)}
          </Text>
          */}
          <Text style={{ fontWeight: "bold", fontSize: 14 }}>
            ACMEG Data #: {v.model?.id}
          </Text>
        </View>
      </View>
    );
  };

  const getFromTo = () => {
    return (
      <>
        <View
          style={{
            margin: "10px 40px 0px 40px",
            color: "#fff",
            fontSize: 11,
            paddingTop: 3,
            backgroundColor: "#8B0000",
            display: "flex",
            justifyContent: "space-between",
            fontFamily: "amiriB",
            flexDirection: "row"
          }}
        >
          <Text style={{ width: "50%", textAlign: "center" }}>FROM</Text>
          <Text style={{ fontWeight: "bold" }}>
            Date: {v.com.getDate(v.model?.shipping_date)}
          </Text>
          <Text
            style={{
              width: "50%",
              textAlign: "center"
            }}
          >
            {" "}
            SHIP TO
          </Text>
        </View>
        <View
          style={{
            margin: "0px 40px",
            fontSize: 11,
            fontFamily: "amiriR",
            display: "flex",
            lineHeight: 1,
            flexDirection:
              v?.model?.invoice_type?.value === 1 ? "row" : "row-reverse",
            justifyContent: "space-between",
            border: "1px solid #8B0000"
          }}
        >
          <View
            style={{
              display: "flex",
              gap: 3,
              padding: "5px 10px 10px",
              width: "50%"
            }}
          >
            {/* <Text style={{ fontWeight: 'bold', fontFamily: 'amiriB', fontSize: 11 }}>{v?.model?.invoice_type?.value === 1 ? "FROM: " : 'SHIP TO'}</Text> */}
            <Text style={{ fontFamily: "amiriB" }}>
              {cw(v?.model?.company?.name_en)}
            </Text>
            <Text>
              <Text style={{ fontFamily: "amiriB" }}>Address: </Text>{" "}
              {cw(v?.model?.company?.address)}
            </Text>
            {/*    <Text>TIN No.: {v?.model?.company?.tin_number}</Text>
                <Text>License No : {v?.model?.company?.license_number}</Text> */}
            <Text>
              <Text style={{ fontFamily: "amiriB" }}>Phone: </Text>
              {v?.model?.company?.phone}
            </Text>
            <Text>
              <Text style={{ fontFamily: "amiriB" }}>Email: </Text>{" "}
              {v?.model?.company?.email}
            </Text>
             <Text>
              <Text style={{ fontFamily: "amiriB" }}>License No.: </Text>{" "}
              {v?.model?.company?.license_number}
            </Text>
            {v?.model?.from?.rex_number && (
              <Text>
                <Text style={{ fontFamily: "amiriB" }}>Rex. No.: </Text>
                {v?.model?.from?.rex_number}
              </Text>
            )}
          </View>

          <View
            style={{
              display: "flex",
              gap: 3,
              padding: "5px 10px 10px",
              width: "50%",
              borderLeft: "1px solid #8B0000"
            }}
          >
            {/*  <Text style={{ fontWeight: 'bold', fontFamily: 'amiriB', fontSize: 11 }}>{v?.model?.invoice_type?.value !== 1 ? "FROM" : 'SHIP TO'}:</Text> */}
            <Text style={{ fontFamily: "amiriB" }}>
              {cw(v?.model?.shipping_name)}
            </Text>
            {v?.model?.shipping_address && (
              <Text>
                <Text style={{ fontFamily: "amiriB" }}>Address: </Text>{" "}
                {cw(v?.model?.shipping_address)}
              </Text>
            )}
            <Text>
              <Text style={{ fontFamily: "amiriB" }}>City: </Text>{" "}
              {v?.model?.shipping_city}
            </Text>
            <Text>
              <Text style={{ fontFamily: "amiriB" }}>Country: </Text>{" "}
              {v?.model?.shipping_state?.name}
            </Text>
            {v?.model?.shipping_phone && (
              <Text>
                <Text style={{ fontFamily: "amiriB" }}>Phone: </Text>{" "}
                {v?.model?.shipping_phone}
              </Text>
            )}
            {v?.model?.shipping_email && (
              <Text>
                <Text style={{ fontFamily: "amiriB" }}>Email: </Text>{" "}
                {v?.model?.shipping_email}
              </Text>
            )}
          </View>
        </View>
      </>
    );
  };

  const getItemsTable = () => {
    return (
      <>
        {v.model?.tariff?.items && (
          <View style={{ margin: "0px 40px" }}>
            <Table
              v={{
                items: v.model?.tariff?.items,
                com: v.com,
                currency: v.model?.currency,
                grossTotal: v?.model?.gross_total
              }}
            />
          </View>
        )}

        <View
          style={{
            display: "flex",
            flexDirection: "row",
            fontSize: 9,
            justifyContent: "space-between",
            padding: "3px 40px"
          }}
        >

          <Text>
            TOTAL PRICE IN (WORDS):{" "}
            {v?.toWords(v?.model?.currency?.label).convert(v?.model?.amount)}.
          </Text>
        </View>

        <View
          style={{

            display: "flex",
            alignItems: "center",
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 10
          }}
        >
          {/*     <Text style={{ fontSize: 12, width: '180px', fontWeight: 'bold', fontFamily: 'amiriB', paddingLeft: 10, marginBottom: 10 }}>Subtotal : {nf(v?.model?.amount)} {v?.model?.currency?.label}</Text> */}
          <Text style={{ fontSize: 10, padding: "3px 40px", fontStyle: 'italic' }}>
            CERTIFIED THAT ABOVE GOODS ARE OF AFGHANISTAN ORIGIN.
          </Text>
          <Text
            style={{
              fontSize: 15,
              backgroundColor: "#8B0000",
              paddingLeft: 10,
              paddingTop: 4,
              color: "#fff",
              width: "180px",
              height: 25,
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            Total : {nf(v?.model?.amount)} {v?.model?.currency?.label}
          </Text>
        </View>
      </>
    );
  };
  return (
    <Document>
      <Page size="A4">
           <Image src={watermark} style={styles.watermarkImage} />
        {getTopHeader()}

        {getRedHeader()}
        {/*  {v?.model?.from?.rex_number && <View style={{ display: 'flex', flexDirection: 'row', fontSize: 11, justifyContent: 'space-between', padding: '5px 40px' }}>
                    <Text></Text>
                    <Text style={{ fontStyle: 'italic' }}>Rex. No. {v?.model?.from?.rex_number}</Text>
                </View>} */}
        {getFromTo()}

        {v?.model?.transit_via && (
          <View
            style={{
              margin: "0px 40px",
              padding: "5px 10px",
              fontSize: 10,
              border: "1px solid #8B0000"
            }}
          >
            <Text style={{ fontFamily: "amiriB" }}>Through</Text>
            <Text style={{ textTransform: "capitalize" }}>
              Via: {v?.model?.transit_via}
            </Text>
          </View>
        )}

        {getItemsTable()}

        <View
          style={{
            display: "flex",
            flexDirection: "row",
            fontSize: 12,
            justifyContent: "space-between",
            padding: "40px"
          }}
        >
       

          <Text>Company Signature</Text>
          <Text>ACMEG Signature</Text>
          <Text>ACCI Signature</Text>
        </View>
      </Page>
    </Document>
  );
}
const styles1 = StyleSheet.create({
  flexRowReverse: {
    flexDirection: "row-reverse",
    lineHeight: 1.5,
    flexWrap: "wrap",
    fontSize: 10
  },
  ml1: {
    marginLeft: "3pt"
  }
});

const styles = StyleSheet.create({
  logo_h: {
    maxWidth: "100%",
    height: 90,
    objectFit: "contain",
    borderRadius: "5%",
    padding: 3
  },
  watermarkImage: {
    position: 'absolute',
    top: '35%',
    left: '30%',
    transform: 'translate(-50%, -50%)',
    width: '60%',      // adjust as needed
    opacity: 0.02,
  },

  header: {
    width: "100%",
    height: 100,
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: "#8B0000",
    padding: 5,
    marginBottom: 10
  },

  bahijB: {
    fontFamily: "bahijB"
  },

  redHeader: {
    color: "#fff",
    height: 28,
    width: "40%",
    backgroundColor: "#8B0000",
    display: "flex",
    flexDirection: "row",
    paddingLeft: 40,
    alignItems: "center",
    position: "relative"
  }
});
